import { AddCardIcon, CashIcon, Title } from "lola-framework-ui-test";
import { PayoutInfo } from "./PayoutInfo";
import { useStore } from "../store/globalState";
import { useNavigate } from "react-router-dom";
import { M2M_ROUTES } from "../constants";
import { paymentType } from "../interfaces/payment";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import masterCardLogo from "../assets/master_card_icon.svg";
import visaLogo from "../assets/visa_color_icon.svg";

export interface SelectPaymentMethodSlotProps {
  onClose: () => void;
}

export const SelectPaymentMethodSlot: React.FC<
  SelectPaymentMethodSlotProps
> = ({ onClose }) => {
  const { t } = useTranslation();
  const { theme, setPaymentState, cardList } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy, backgroundBtn, textColorBtn } = colorConfig;
  const navigate = useNavigate();

  const onSelectPayment = ({
    cardId,
    type,
    brand,
  }: {
    cardId: string | null;
    type: paymentType;
    brand: string;
  }) => {
    setPaymentState({
      payment: {
        cardId,
        type,
        brand,
      },
    });
    onClose();
  };

  const items = cardList.map((card) => ({
    cardId: card.cardId,
    type: paymentType.CARD,
    brand: card.name,
  }));

  const pickIcon = useCallback((brand: string) => {
    let finalIcon = null;
    if (brand.toLocaleUpperCase().includes("VISA")) finalIcon = visaLogo;
    if (brand.toLocaleUpperCase().includes("MASTERCARD"))
      finalIcon = masterCardLogo;

    return {
      brand,
      icon: <img src={finalIcon ?? ""} alt={`${brand} logo`} />,
    };
  }, []);

  return (
    <section className="select-payer-slot">
      <Title title={t("payment.selectMethod")} align="center" color={bodyCopy} />
      <section
        className="select-payer-list"
        style={
          {
            "--bgIcon": backgroundBtn,
            "--iconOnBrand": textColorBtn,
          } as React.CSSProperties
        }
      >
        <PayoutInfo
          title={t("payment.cashDeposit")}
          subtitle={t("payment.minMax", { min: "25 USD", max: "190 USD" })}
          icon={<CashIcon size={20} />}
          fee={<label className="footer-text">{t("payment.fee", { amount: "$3.11 USD" })}</label>}
          onChange={() =>
            onSelectPayment({ cardId: null, type: paymentType.CASH, brand: t("payment.cashDeposit") })
          }
        />
        {items.map(({ cardId, brand }, index) => (
          <PayoutInfo
            key={index}
            title={brand ?? ""}
            subtitle={t("payment.minMax", { min: "25 USD", max: "190 USD" })}
            icon={pickIcon(brand ?? "").icon}
            fee={<label className="footer-text">{t("payment.fee", { amount: "$2.10 USD" })}</label>}
            onChange={() =>
              onSelectPayment({ cardId, type: paymentType.CARD, brand: brand ?? "" })
            }
          />
        ))}
        <PayoutInfo
          title={t("payment.addDebitCard")}
          subtitle={t("payment.minMax", { min: "25 USD", max: "190 USD" })}
          icon={<AddCardIcon size={20} colors={[textColorBtn, textColorBtn]} />}
          fee={<label className="footer-text">{t("payment.fee", { amount: "$2.10 USD" })}</label>}
          onChange={() => navigate(M2M_ROUTES.ADD_CARD)}
        />
      </section>
    </section>
  );
};
